import { computed, onMounted, watch } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import { useRoute } from 'vue-router'
import type { CoachSurveyRecurrenceSettings } from '@/modules/coach-surveys/composables/use-coach-survey'
import type { SurveyState } from '@/modules/survey/models/survey-state'
import type { Member } from '@/core/models/member/member'

export const useCoacheeTodos = () => {
  const route = useRoute()

  const coacheeId = computed(() => route.params.id as string)

  const endpoint = computed(() => `coaching/coachee/${coacheeId.value}/todos`)

  const { data, load, status } = useGet<CoacheeTodos>(endpoint)

  onMounted(() => load())

  watch(coacheeId, () => {
    load()
  })

  return {
    data,
    status,
  }
}

export interface CoacheeTodos {
  readonly feedbackGoals: ReadonlyArray<{
    readonly id: string
    readonly feedbackTopic: { id: string; title: string; icon?: string }
    readonly isActive: boolean
    readonly lastDialogConductedAt: string | null
    readonly progress: ReadonlyArray<{
      readonly perspectiveKey: string
      readonly count: number
      readonly target: number
    }>
  }>
  readonly coacheeSurveys: ReadonlyArray<{
    readonly id: string
    readonly title?: string
    readonly createdAt: string
    readonly feedbackTopic: { id: string; title: string; icon?: string }
    readonly recurrence?: CoachSurveyRecurrenceSettings
    readonly occurrences: ReadonlyArray<{
      readonly id: string
      readonly state: SurveyState
      readonly startDate: string
      readonly hasAnswered: boolean
    }>
  }>
  readonly assessments: ReadonlyArray<{
    readonly id: string
    readonly title?: string
    readonly feedbackTopic: { id: string; title: string; icon?: string }
    readonly state: SurveyState
    readonly dueAt?: string
    readonly createdAt: string
    readonly peers: ReadonlyArray<Member>
    readonly includeSelfFeedback: boolean
    readonly selfFeedbackDone: boolean
    readonly finishedPeerIds: ReadonlyArray<string>
  }>
}
